import { create } from "@mui/material/styles/createTransitions";
import parseAPNG from 'apng-js';
import Phaser from 'phaser';

import { levelsConfig } from './LevelsConfig';
import { gameAssets } from './LevelsConfig';
import { WindowSharp } from "@mui/icons-material";

const ingredientCompleted = (scene,animationConfig, itemConfig, clickedObject) => {
    scene?.ingredientCompleted(animationConfig, itemConfig, clickedObject);
}


export const createImage = (scene, gameObjects, item, optinalID) => {

    return new Promise((resolve, reject) => {
        let itemScale = item.scale || 1;

        let media = optinalID || item.media;


        let x = item.x;
        let y = item.y;


        // Add the media to the game
        if (item.media) {

            const isAPNG = item.media && item.media.toLowerCase().endsWith('.apng');

            if (isAPNG) {
                // Handle APNG files
                //item media path is the path to the apng file gameAssets

                let apngPath = gameAssets.media.images[item.media];

                fetch(apngPath)
                    .then((response) => response.arrayBuffer())
                    .then((buffer) => parseAPNG(buffer))
                    .then((apng) => {
                        if (apng instanceof Error) {
                            console.error('Failed to parse APNG:', apng);
                            reject(apng);
                        } else {
                            // Create a canvas and render APNG frames
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');
                            canvas.width = apng.width;
                            canvas.height = apng.height;

                            let frameIndex = 0;

                            const renderFrame = () => {
                                // Get the frame's Blob data
                                const frame = apng.frames[frameIndex];
                                const blob = frame.imageData;

                                // Create a URL for the Blob
                                const imageUrl = URL.createObjectURL(blob);

                                // Create an HTMLImageElement and set the Blob URL as the source
                                const img = new Image();
                                img.onload = () => {
                                    // Calculate the position to center the image horizontally
                                    const x = (canvas.width - img.width) / 2;
                                    const y = 0; // Keep the y coordinate at 0 to align it to the top

                                    // Draw the image onto the canvas at the calculated position
                                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                                    ctx.drawImage(img, x, y);

                                    ctx.globalAlpha = (item.alpha !== undefined) ? item.alpha : 1;

                                    // Refresh the texture in Phaser
                                    scene.textures.get(media).source[0].update();

                                    // Revoke the Blob URL after the frame has been rendered
                                    URL.revokeObjectURL(imageUrl);

                                    // Move to the next frame and schedule the next render
                                    frameIndex = (frameIndex + 1) % apng.frames.length;
                                    setTimeout(renderFrame, frame.delay || 250);
                                };

                                img.src = imageUrl;
                            };

                            // Start rendering the APNG
                            renderFrame();

                            // Add the canvas to Phaser
                            scene.textures.addCanvas(media, canvas);
                            let gameImage = scene.add.image(x, y, media).setOrigin(0, 0)
                            gameImage.setInteractive();

                            if (itemScale !== 1) {
                                gameImage.setScale(itemScale);
                                gameImage.setDepth(999);
                            }

                            gameImage.assets = [];
                            gameImage.itemConfig = item;
                            gameImage.srcScale = itemScale;
                            gameImage.subSectionID = item.subSectionID;
                            gameImage.id = media;

                            // gameImage.on('pointerdown', () => {
                            //     alert('Sprite clicked!');
                            // });

                            if (window.ENABLE_DRAG) scene.input.setDraggable(gameImage);

                            gameObjects.push(gameImage);
                            resolve(gameImage);
                        }
                    })
                    .catch((error) => {
                        console.error('Error loading APNG:', error);
                        reject(error);
                    });
            }else{
                scene.loadImage(item.media).then(() => {
                    let gameImage = scene.make.image({
                        x: x,
                        y: y,
                        key: item.media,
                        add: true,
                    })
                        .setOrigin(0, 0)
                        .setInteractive()
                        .setAlpha(0);

                        

                    if(itemScale !== 1) {
                        gameImage.setScale(itemScale);
                    }

                    gameImage.assets = [];

                    gameImage.itemConfig = item;
                    gameImage.srcScale = itemScale;//to track
                    gameImage.subSectionID = item.subSectionID;

                    gameImage.id = media;
                    //console.log("media", media, "displaySize (w,h)", width, height, "position (x,y)", x, y);
                    // gameImage.setPosition(-20, phaserGame.clientHeight - height);

                    

                    let width = gameImage.width * itemScale;
                    let height = gameImage.height * itemScale;

                    //if the item has a fixedHeight property the adjust the width and height to match the fixedHeight keeping the aspect ratio
                    if (item.fixedHeight) {
                        let aspectRatio = gameImage.width / gameImage.height;
                        height = item.fixedHeight;
                        width = height * aspectRatio;
                        gameImage.setDisplaySize(width, height);
                    }

                    let label = null;

                    if (item.label) {
                        //create label center under the image (take into account the scale and the width of the label)
                        label = createLabel(scene, gameObjects, { x: x + (width / 2), y: y + height + 40, label: item.label, subSectionID: item.subSectionID, alpha:item.alpha || 0 });    
                        label.setAlpha(0);
                    }

                    if (item.fadeInOnAudioEvent) {
                        //listen for below event fired in audio player and trigger
                        //and check if the currentTime > timeStamp and viewId matches
                        //then fade in the image
                        /*const event = new CustomEvent('autoTrackProgressEvent', {
                            detail: {
                                audioUrl: audioUrl,
                                viewId: viewId,
                                currentTime: e.srcElement.currentTime,
                                duration: e.srcElement.duration,
                                progress: (e.srcElement.currentTime / e.srcElement.duration) * 100
                            }, // Add event-specific data
                        });
                        window.dispatchEvent(event); // Dispatch the event*/

                        const getFileName = (path) => path.split('/').pop();

                        // Define the event handler function
                        gameImage.autoTrackProgressEventHandler = function (e) {
                            // console.log("autoTrackProgressEventHandler:", item.label, "audioUrlCheck: " + (getFileName(e.detail.audioUrl) === getFileName(item.fadeInOnAudioEvent.audio)),
                            //     "viewId: "+(e.detail.viewId === item.fadeInOnAudioEvent.viewId),
                            //     "currentTimeCheck: " + (e.detail.currentTime >= item.fadeInOnAudioEvent.timeStamp),
                            //     "alphaCheck :" +(this.alpha === 0), "Time: "+e.detail.currentTime, "TimeStamp: "+item.fadeInOnAudioEvent.timeStamp, "full data: ", item, e
                            // );

                            if (getFileName(e.detail.audioUrl) === getFileName(item.fadeInOnAudioEvent.audio) &&
                                e.detail.viewId === item.fadeInOnAudioEvent.viewId &&
                                e.detail.currentTime >= item.fadeInOnAudioEvent.timeStamp &&
                                (this.alpha === 0)
                            ) {
                                console.log("autoTrackProgressEventHandler: !!Made It: fadeInOnAudioEvent", item.label);



                                // Fade in the image
                                scene.tweens.add({
                                    targets: this,
                                    alpha: { from: 0, to: 1 },
                                    duration: 500, // Duration in milliseconds
                                    ease: 'Linear', // 'Linear' for a steady fade; you can try other easing functions too
                                    onComplete: () => {
                                        // Remove the event listener once the tween is complete
                                        //window.removeEventListener('autoTrackProgressEvent', autoTrackProgressEventHandler);
                                        console.log("autoTrackProgressEventHandler fadeInOnAudioEvent onComplete", e.detail);
                                    },
                                });
                                // this.alpha = 1;
                        
                                // Fade in the label
                                if (label) {
                                    label.alpha = 1;
                                    console.log("autoTrackProgressEventHandler fadeInOnAudioEvent label", label);
                                }
                                //remove event listener if the item has a oneTimeOnly property
                                window.removeEventListener('autoTrackProgressEvent', this.autoTrackProgressEventHandler);
                            }
                        }.bind(gameImage);
                        
                        // Add the event listener
                        window.addEventListener('autoTrackProgressEvent', gameImage.autoTrackProgressEventHandler);
                    }

                    // Make the object draggable
                    if (window.ENABLE_DRAG) {
                        scene.input.setDraggable(gameImage);
                        console.log("ENABLE_DRAG", gameImage,scene.input);
                    }

                    window.scene = scene;

                    //set cursor to pointer on hover
                    gameImage.on('pointerover', () => {
                        scene.input.setDefaultCursor('default');
                    });

                    gameImage.on('pointerout', () => {
                        scene.input.setDefaultCursor('pointer');
                    });

                    //create click event for animations
                    gameImage.on('pointerdown', 
                        gameImagePointerDown(scene, gameObjects)
                    );
                    

                    // gameImage.on('pointerdown', () => {
                    //     console.log('Pointer down detected on the image!');
                    //     gameImage.setTint(0xff0000); // Example action: Tint the image red
                    // });


                    gameObjects.push(gameImage);
                    //return gameImage;
                    resolve(gameImage);
                });
            }
        }
    });
}

//new create image
// export const createImage = (scene, gameObjects, item, optionalID) => {
//     return new Promise((resolve, reject) => {
//         let itemScale = item.scale || 1;
//         let media = optionalID || item.media;
//         let x = item.x;
//         let y = item.y;

//         const isAPNG = item.media && item.media.toLowerCase().endsWith('.apng');

//         //alert('broke something with old images., need to review updates and fix before commiting')

//         if (item.media) {
//             if (isAPNG) {
//                 // Handle APNG files
//                 //item media path is the path to the apng file gameAssets

//                 let apngPath = gameAssets.media.images[item.media];

//                 fetch(apngPath)
//                     .then((response) => response.arrayBuffer())
//                     .then((buffer) => parseAPNG(buffer))
//                     .then((apng) => {
//                         if (apng instanceof Error) {
//                             console.error('Failed to parse APNG:', apng);
//                             reject(apng);
//                         } else {
//                             // Create a canvas and render APNG frames
//                             const canvas = document.createElement('canvas');
//                             const ctx = canvas.getContext('2d');
//                             canvas.width = apng.width;
//                             canvas.height = apng.height;

//                             let frameIndex = 0;

//                             const renderFrame = () => {
//                                 // Get the frame's Blob data
//                                 const frame = apng.frames[frameIndex];
//                                 const blob = frame.imageData;

//                                 // Create a URL for the Blob
//                                 const imageUrl = URL.createObjectURL(blob);

//                                 // Create an HTMLImageElement and set the Blob URL as the source
//                                 const img = new Image();
//                                 img.onload = () => {
//                                     // Draw the image onto the canvas
//                                     ctx.clearRect(0, 0, canvas.width, canvas.height);
//                                     ctx.drawImage(img, 0, 0);

//                                     // Refresh the texture in Phaser
//                                     scene.textures.get(media).source[0].update();

//                                     // Revoke the Blob URL after the frame has been rendered
//                                     URL.revokeObjectURL(imageUrl);

//                                     // Move to the next frame and schedule the next render
//                                     frameIndex = (frameIndex + 1) % apng.frames.length;
//                                     setTimeout(renderFrame, frame.delay || 100);
//                                 };

//                                 img.src = imageUrl;
//                             };

//                             // Start rendering the APNG
//                             renderFrame();

//                             // Add the canvas to Phaser
//                             scene.textures.addCanvas(media, canvas);
//                             let gameImage = scene.add.image(x, y, media).setOrigin(0, 0)

//                             if (itemScale !== 1) {
//                                 gameImage.setScale(itemScale);
//                                 gameImage.setDepth(999);
//                             }

//                             gameImage.assets = [];
//                             gameImage.itemConfig = item;
//                             gameImage.srcScale = itemScale;
//                             gameImage.subSectionID = item.subSectionID;
//                             gameImage.id = media;

//                             //if (window.ENABLE_DRAG) scene.input.setDraggable(gameImage);

//                             gameObjects.push(gameImage);
//                             resolve(gameImage);
//                         }
//                     })
//                     .catch((error) => {
//                         console.error('Error loading APNG:', error);
//                         reject(error);
//                     });
//             } else {
//                 // Handle regular static images
//                 scene.loadImage(item.media).then(() => {
//                     let gameImage = scene.make.image({
//                         x: x,
//                         y: y,
//                         key: item.media,
//                         add: true,
//                     })
//                         .setOrigin(0, 0)
//                         .setInteractive()
//                         .setAlpha(0);

//                     if (itemScale !== 1) {
//                         gameImage.setScale(itemScale);
//                     }


//                     gameImage.assets = [];
//                     gameImage.itemConfig = item;
//                     gameImage.srcScale = itemScale;
//                     gameImage.subSectionID = item.subSectionID;
//                     gameImage.id = media;

//                     if (window.ENABLE_DRAG) scene.input.setDraggable(gameImage);

//                     gameObjects.push(gameImage);
//                     resolve(gameImage);
//                 });
//             }
//         }
//     });
// };



//END createImage

window.spines = [];

export const createSpine = (scene, gameObjects, item) => {
    return new Promise((resolve, reject) => {
        

        scene.load.on('complete', function () {
            //trigger spineComplete on window
            
            //create spine
            // const s = scene.add.spine(item.x, item.y, item.id + '-json', item.id + '-atlas');
            const s = scene.add.spine(item.x, item.y, item.id, null,true)
            window.spines.push(s);
            s.setInteractive();
            s.scale = item.scale;//75% scale
            s.id = item.id;
            s.currentAnimationIndex = 0;
            s.timeScale = item.timeScale || 1;
            // s.animationState.timeScale = item.timeScale;//set animation speed to 25%
            s.skeleton.setToSetupPose();
            s.alpha = item.alpha || 0;//hide it initially
            //s.alpha = item.alpha || 1;
            // s.alpha = 0;//hide it initially
            s.timeScale = item.timeScale || 1;

            s.addListener('start', (event) => {
                console.log('Spine Event Name:', event.animation.name, 'Spine ID:', s.id, 'Event: start',);
                //echo event to window
                window.dispatchEvent(new CustomEvent('spineEvent', { detail: { 
                    event: event, 
                    spine: s,
                    animationName: event.animation.name,
                    id: s.id,
                    eName:'start'
                } }));
            });

            s.addListener('end', (event) => {
                console.log('Spine Event Name:', event.animation.name, 'Spine ID:', s.id, 'Event: end',);

                window.dispatchEvent(new CustomEvent('spineEvent', {
                    detail: {
                        event: event,
                        spine: s,
                        animationName: event.animation.name,
                        id: s.id,
                        eName:'end'
                    }
                }));
            });

            s.addListener('complete', (event) => {
                console.log('Spine Event Name:', event.animation.name, 'Spine ID:', s.id, 'Event: complete',);

                window.dispatchEvent(new CustomEvent('spineEvent', {
                    detail: {
                        event: event,
                        spine: s,
                        animationName: event.animation.name,
                        id: s.id,
                        eName:'complete'
                    }
                }));
            });

            //play and stop this animation
            if (item.playDefault) {
                s.play(item.playDefault, false);
            }

            //set the layer to 999
            s.setDepth(999);

            if (item.autoPlay) {
                s.play(item.autoPlay, item.loop || false);
            }


            s.subSectionID = item.subSectionID;

            // Make the object draggable
            if (window.ENABLE_DRAG)
                scene.input.setDraggable(s);

            s.itemConfig = item;
            gameObjects.push(s);

            resolve(item);
            console.log("spine loaded", item.id, item.json, item.atlas);
        });

        //load spine json
        console.log("loading spine", item.id, item.json, item.atlas);
        scene.load.spine(item.id, item.json, item.atlas);
    });
    
}

export const createLabel = (scene, gameObjects, item) => {
    if (item.label) {
        let x = item.x;
        let y = item.y;

        // Create a Graphics object for the border and background
        let graphics = scene.add.graphics();

        // Set style for the rounded rectangle
        graphics.fillStyle(0xffffff, 1); // White fill
        graphics.lineStyle(2, 0x5F3913, 1); // Brown border

        // Create text
        let label = scene.add.text(0, 0, item.label, {
            fontFamily: 'Helvetica Neue',
            fontSize: '24px',
            color: '#5F3913',
            align: 'center',
            backgroundColor: null
        });

        // Get the actual height and width of the text
        let textWidth = label.width;
        let textHeight = label.height;

        // Calculate padding and total width/height for the background
        let padding = 8;
        let totalWidth = textWidth + 2 * padding;
        let totalHeight = textHeight + 2 * padding;

        // Draw the rounded rectangle at (0, 0) within the container
        graphics.fillRoundedRect(-totalWidth / 2, -totalHeight / 2, totalWidth, totalHeight, 10);
        graphics.strokeRoundedRect(-totalWidth / 2, -totalHeight / 2, totalWidth, totalHeight, 10);

        // Adjust text position to be within the graphics
        label.setPosition(-textWidth / 2, -textHeight / 2);

        // Create a container to group the label and the background
        //let labelContainer = scene.add.container(x + totalWidth / 2, y + totalHeight / 2);
        let labelContainer = scene.add.container(x, y);
        labelContainer.add(graphics);
        labelContainer.add(label);

        // Define the hit area for the container
        let hitArea = new Phaser.Geom.Rectangle(0, 0, totalWidth, totalHeight);
        labelContainer.setSize(totalWidth, totalHeight);
        labelContainer.setInteractive(hitArea, Phaser.Geom.Rectangle.Contains);
        

        // Make the container draggable
        //scene.input.setDraggable(labelContainer);

        labelContainer.itemConfig = item;
        labelContainer.subSectionID = item.subSectionID;
        labelContainer.alpha = 0;
        labelContainer.setAlpha(0);//labels are hidden by default

        gameObjects.push(labelContainer);

        return labelContainer;
    }
}






export const createGameLevels = (scene, game, gameLevel) => {

    return new Promise((resolve, reject) => {

        //array of objects we return
        let gameObjects = [];

        // Get the level config
        let levelConfig = levelsConfig.find(lc => lc.name === gameLevel);

        let resourcePromises = [];

        // Loop through the layout and add the media to the game
        levelConfig.layout.forEach(item => {

            let type = item.type;

            if(type === 'image' || !type) {
                resourcePromises.push(createImage(scene, gameObjects, item));

            }else if(type === 'spine') {
                resourcePromises.push(createSpine(scene, gameObjects, item));
                //createSpine(scene, gameObjects, item);
            } else if (type === 'label') {
                createLabel(scene, gameObjects, item);
            }
        });

        // if(loadingSpines.length === 0) {
        //     scene.load.start();
        // }else{
        //     Promise.all(loadingSpines).then(() => {
        //         scene.load.start();
        //         alert("here");
        //     });
        // }

        //start the scene load

        scene.load.start();

        Promise.all(resourcePromises).then(() => {
            //only fade in gameObjects with alpha > 0
            let gameObjectsToFadeIn = gameObjects.filter(item => (item.itemConfig.alpha === null || (item.itemConfig.alpha !== 0)) && !item.itemConfig.initHidden);

            //add tween to fade in the objects
            scene.tweens.add({
                targets: gameObjectsToFadeIn, // Replace with the items you want to fade out
                alpha: { from: 0, to: 1 },
                duration: 500, // Duration in milliseconds
                ease: 'Linear', // 'Linear' for a steady fade; you can try other easing functions too
                onComplete: () => {
                },
            });

            //add click events for onClick actions: onClick: { action: 'show', items: ["myplate_veggies_hover"] }
            gameObjects.forEach(item => {
                if (item.itemConfig?.onClick) {
                    item.on('pointerdown', function (pointer) {
                        let action = item.itemConfig.onClick.action;
                        let items = item.itemConfig.onClick.items;

                        if (action === "show") {
                            items.forEach(item => {
                                let obj = gameObjects.find(obj => obj.id === item);
                                if (obj) {
                                    //fade out object with tween
                                    scene.tweens.add({
                                        targets: obj,
                                        alpha: 1,
                                        duration: 500,
                                        ease: 'Linear'
                                    });
                                }
                            });
                        }

                        //hide
                        if (action === "hide") {
                            items.forEach(item => {
                                let obj = gameObjects.find(obj => obj.id === item);
                                if (obj) {
                                    //fade out object with tween
                                    scene.tweens.add({
                                        targets: obj,
                                        alpha: 0,
                                        duration: 500,
                                        ease: 'Linear'
                                    });
                                }
                            });
                        }

                        //toggle - hide is alpha is 1 show if alpha is 0
                        if (action === "toggle") {
                            items.forEach(item => {
                                let obj = gameObjects.find(obj => obj.id === item);
                                if (obj) {
                                    if (obj.alpha === 1) {
                                        //fade out object with tween
                                        scene.tweens.add({
                                            targets: obj,
                                            alpha: 0,
                                            duration: 500,
                                            ease: 'Linear'
                                        });
                                    } else {
                                        //fade out object with tween
                                        scene.tweens.add({
                                            targets: obj,
                                            alpha: 1,
                                            duration: 500,
                                            ease: 'Linear'
                                        });
                                    }
                                }
                            });
                        }

                    });
                }
            });



            if (window.ENABLE_DRAG) {
                // scene.input.on('dragstart', (pointer, gameObject) => {
                //     scene.children.bringToTop(gameObject);
                // });

                scene.input.on('drag', (pointer, gameObject, dragX, dragY) => {
                    debugger;
                    gameObject.x = dragX;
                    gameObject.y = dragY;

                    //console.log("drag", gameObject.x, gameObject.y);

                    //output in this format, note scale can be and should be left out: { "media": "knife", "x": 773, "y": 585, "width": 320, "height": 1532, scale: 0.5 }
                    console.log(`{ "media": "${gameObject.id}", "x": ${Math.round(gameObject.x)}, "y": ${Math.round(gameObject.y)}, "width": ${gameObject.width}, "height": ${gameObject.height}, scale: ${gameObject.srcScale} },`);
                    //console.log(JSON.stringify(gameObject));
                });
            }
            resolve(gameObjects);
        });

        

    });
}

function gameImagePointerDown(scene, gameObjects) {
    console.log("gameImagePointerDown create function");
    return function () {
        console.log("gameImagePointerDown action event");

        // alert("gameImagePointerDown");

        
        // This code will be executed when the image is clicked
        // Additional logic goes here
        //when the this.itemConfig has the action of type click with animation
        //we need to loop through all the game objects and find the spine with the id and play the animation with the timeScale
        /*{ "media": "carrots", "x": 288, "y": 271, "width": 2160, "height": 1520, scale: 0.5,
            "action": { type: "click", animation: { spine: "choppingVeggies", animation:"chop_carrots",timeScale:0.10}}
        },*/
        let itemConfig = this.itemConfig;
        let clickedObject = this;

        let actions = Array.isArray(itemConfig?.action) ? itemConfig.action : [itemConfig?.action];

        actions.forEach(action => {
            if(!action) return;

            console.log('action?.type', action?.type,action);
            if (action?.type === "click") {
                if (action?.function) {
                    action.function(scene, itemConfig, clickedObject);
                }

                //show function for images
                if (action?.show) {
                    action.show.forEach(item => {
                        let obj = gameObjects.find(obj => obj.id === item);
                        if (obj) {
                            //fade in object with tween
                            scene.tweens.add({
                                targets: obj,
                                alpha: 1,
                                duration: 500,
                                ease: 'Linear'
                            });
                        }
                    });
                }

                //hide function for images
                if (action?.hide) {
                    action.hide.forEach(item => {
                        let obj = gameObjects.find(obj => obj.id === item);
                        if (obj) {
                            //fade out object with tween
                            scene.tweens.add({
                                targets: obj,
                                alpha: 0,
                                duration: 500,
                                ease: 'Linear'
                            });
                        }
                    });
                }

                //toggle function for images
                if (action?.toggle) {
                    action.toggle.forEach(item => {
                        let obj = gameObjects.find(obj => obj.id === item);
                        if (obj) {
                            if (obj.alpha === 1) {
                                //fade out object with tween
                                scene.tweens.add({
                                    targets: obj,
                                    alpha: 0,
                                    duration: 500,
                                    ease: 'Linear'
                                });
                            } else {
                                //fade out object with tween
                                scene.tweens.add({
                                    targets: obj,
                                    alpha: 1,
                                    duration: 500,
                                    ease: 'Linear'
                                });
                            }
                        }
                    });
                }

                if (action?.oneTimeOnly) {
                    itemConfig.action = null;
                    clickedObject.alpha = 0.5;
                    //set image to black and white
                    // clickedObject.setTint(0x000000);
                }


                let animationConfig = action?.animation;
                if (animationConfig) {
                    //trigger spine animation
                    let spine = gameObjects.find(item => item.id === animationConfig.spine);
                    if (spine) {
                        if (animationConfig.timeScale)
                            spine.timeScale = animationConfig.timeScale;
                        spine.alpha = 1;

                        if (spine.itemConfig.onStart) {
                            spine.itemConfig.onStart(spine, spine.scene, animationConfig, itemConfig, clickedObject);
                        }

                        //set the animation complete listener without animationState
                        spine.on('complete', function (track, loopCount) {
                            spine.removeListener(this);

                            if (spine.itemConfig.onComplete) {
                                spine.itemConfig.onComplete(spine, spine.scene, animationConfig, itemConfig, clickedObject);
                            }

                            // You can perform any actions or trigger events here
                            spine.alpha = animationConfig.alpha || 0;
                            if (animationConfig.onComplete) {
                                spine.itemConfig.onComplete(spine.scene, animationConfig, itemConfig, clickedObject);
                            }

                            if (animationConfig.onCompleteHide) {
                                animationConfig?.onCompleteHide?.forEach(item => {
                                    let obj = gameObjects.find(obj => obj.id === item);
                                    if (obj) {
                                        //fade out object with tween
                                        scene.tweens.add({
                                            targets: obj,
                                            alpha: 0,
                                            duration: 500,
                                            ease: 'Linear'
                                        });
                                    }
                                });
                            }

                            if (animationConfig.onCompleteShow) {
                                animationConfig?.onCompleteShow?.forEach(item => {

                                    let obj = gameObjects.find(obj => obj.id === item);
                                    if (obj) {
                                        //fade out object with tween
                                        scene.tweens.add({
                                            targets: obj,
                                            alpha: obj.itemConfig.displayAlpha || 1,
                                            duration: 250,
                                            ease: 'Linear'
                                        });
                                    }
                                });
                            }
                        });

                        //play spine animation not using animationState
                        spine.play(animationConfig.animation, false);


                        //old way
                        //spine.animationState?.setAnimation(0, animationConfig.animation, false);
                        //if oneTimeOnly is true, remove the action and 
                        //set the alpha to the item to 70% to indicate it has been used
                        if (action?.oneTimeOnly) {
                            itemConfig.action = null;
                            clickedObject.alpha = 0.5;
                            this.alpha = 0.5;


                            //set image to black and white
                            // this.setTint(0x000000);
                        }
                    }
                }
            }
        });

    };
}
//find the configuraton from the phaser game levels and add the resources to the game in the correct positions

